'use client';

import { ChannelVerificationReportPage } from '@flipster/features/src/channel-verification-page/page/report';

const Page = () => {
  return <ChannelVerificationReportPage />;
};

export default Page;
